import { CharlieButton, cn } from '@ver.id/libs.ui.charlie';
import { type FlowAction } from '../../types';

type Props = {
  /** The filled button. At most one per screen. */
  primary?: FlowAction;
  /** The outline button: the way back or out. */
  secondary?: FlowAction;
  /**
   * `col` stacks full-width buttons with the primary on top. `row` places them
   * side by side with the way back on the left.
   */
  direction?: 'col' | 'row';
  pill?: boolean;
  className?: string;
};

/**
 * HostedActionRow — The primary and secondary actions of a flow screen.
 *
 * Pure presentational. Placement is the caller's: HostedMobileLayout renders it in
 * its sticky footer slot, desktop pages inline.
 */
export default function HostedActionRow({
  primary,
  secondary,
  direction = 'col',
  pill = true,
  className,
}: Props) {
  const isRow = direction === 'row';

  const renderButton = (action: FlowAction, variant: 'default' | 'outline') => (
    <CharlieButton
      variant={variant}
      pill={pill}
      block={!isRow}
      className={isRow ? 'flex-1' : undefined}
      loading={action.loading}
      onClick={action.onClick}
    >
      {action.label}
    </CharlieButton>
  );

  return (
    <div
      className={cn(
        'flex gap-3',
        isRow ? 'flex-row' : 'flex-col items-center',
        className,
      )}
    >
      {isRow && secondary && renderButton(secondary, 'outline')}
      {primary && renderButton(primary, 'default')}
      {!isRow && secondary && renderButton(secondary, 'outline')}
    </div>
  );
}
